<template>
    <div>
        <h2>{{ ttt("Log In") }}</h2>
        <form class="form" method="post" :action="url">
            <slot name="social"></slot>

            <div class="separator text4">{{ ttt("OR") }}</div>

            <label for="email">
                <span>{{ ttt("E-Mail Address") }}</span>
                <input
                    type="email"
                    name="email"
                    id="email"
                    v-model="email"
                    :placeholder="ttt('E-Mail Address')"
                />
            </label>

            <div v-cloak class="error" v-if="errors.email">
                <span class="help is-danger" role="alert">
                    <strong v-text="errors.email[0]"></strong>
                </span>
            </div>

            <label for="password">
                <span>{{ ttt("Password") }}</span>
                <input
                    type="password"
                    name="password"
                    id="password"
                    v-model="password"
                    :placeholder="ttt('Password')"
                />
            </label>

            <div v-cloak class="error" v-if="errors.password">
                <span class="help is-danger" role="alert">
                    <strong v-text="errors.password[0]"></strong>
                </span>
            </div>

            <div class="wrapper-checkbox-radio">
                <div class="wrapper-checkbox">
                    <input
                        v-model="remember"
                        type="checkbox"
                        class="checkbox"
                        name="remember"
                        id="remember"
                    />
                    <label class="label-def" for="remember">
                        {{ ttt("Remember Me") }}
                    </label>
                </div>
            </div>

            <input
                class="btn-submit"
                type="submit"
                @click.prevent="submit"
                :value="ttt('Login')"
            />
            <a :href="passwordResetRequestUrl" class="login-link">
                {{ ttt("Forgot Your Password?") }}
            </a>
        </form>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onBeforeMount } from "vue";
import http from "@/services/http";
import { AuthenticatedResponse } from "@/api/v1/auth";
import { i18n } from "@/services/i18n";
import { ResponseErrors } from "@/modules/api/errors";
import { request as passwordResetRequestApi } from "@/routes/password";

export default defineComponent({
    name: "auth-login-form",
    props: {
        url: {
            type: String,
            required: true,
        },
        redirectTo: {
            type: String,
            required: true,
        },
    },
    setup(props) {
        const url = ref(props.url);
        const errors = ref<ResponseErrors>({});
        const email = ref("");
        const password = ref("");
        const remember = ref(false);

        async function submit() {
            errors.value = {};

            const payload = {
                email: email.value,
                password: password.value,
                remember: remember.value,
                redirectTo: props.redirectTo,
            };

            http.post(props.url, payload)
                .then((r) => {
                    const data: AuthenticatedResponse = r.data;

                    window.location.href = data.intended;
                })
                .catch((e) => {
                    if (422 === e.response.status) {
                        errors.value = e.response.data.errors;
                    }
                });
        }

        const passwordResetRequestUrl = computed(() => {
            return passwordResetRequestApi.url();
        });

        onBeforeMount(() => {
            i18n.add("ru", {
                "OR": "Или",
                "Log In": "Войти",
                "Password": "Пароль",
                "E-Mail Address": "E-Mail адрес",
                "Remember Me": "Запомнить меня",
                "Login": "Войти",
                "Forgot Your Password?": "Забыли пароль?",
            });

            i18n.add("uk", {
                "OR": "Або",
                "Password": "Пароль",
                "E-Mail Address": "Електронна адреса",
                "Remember Me": "Запам'ятати мене",
                "Login": "Увійти",
                "Forgot Your Password?": "Забули пароль?",
            });

            i18n.add("pl", {
                "OR": "LUB",
                "Password": "Hasło",
                "E-Mail Address": "Adres e-mail",
                "Remember Me": "Zapamiętaj Mnie",
                "Login": "Logowanie",
                "Forgot Your Password?": "Nie pamiętasz hasła?",
            });
        });

        return {
            url,
            email,
            password,
            errors,
            remember,
            passwordResetRequestUrl,
            submit,
            ttt: i18n.t,
        };
    },
});
</script>
